import React from "react";
import IconHolderInfo from "../../Resources/svg/Icons/IconHolderInfo";
import { getTitleCase } from "../../Utils/simulaciones/simulaciones";

const CardInfo = (props: any) => {
  const client = props.client;

  const GENERO: any = {
    M: "Masculino",
    F: "Femenino",
  };

  const TYPEDOC: any = {
    2: "DNI",
    1: "CE",
    3: "PASAPORTE",
  };

  const modifierGenero = GENERO[client.sexo] || "";
  const modifierTypeDoc = TYPEDOC[client.typeDoc] || "";
  let dataTypeDOc;

  const validateDataClient = Object.keys(client).length === 0;

  let typeDocNoBDU;
  if (modifierTypeDoc === "") {
    typeDocNoBDU = client.typeDoc ? client.typeDoc.valor : "";
    dataTypeDOc = TYPEDOC[typeDocNoBDU];
  }else {
    dataTypeDOc = modifierTypeDoc;
  }

  const names = client.names ? getTitleCase(client.names) : "";
  const firstName = client.firstName ? getTitleCase(client.firstName) : "";
  const lastName = client.lastName ? getTitleCase(client.lastName) : "";

  return (
    <div className="cardInfo">
      <div className="cardInfo__data">
        <div className="cardInfo__data__title">
          {`${names} ${firstName} ${lastName}`}
          {/* {[client.names, client.firstName, client.lastName].join(" ")} */}
        </div>
      </div>
      <div className="cardInfo__data__info">
        <div className="cardInfo__data__items">
          <div className="is--title">{dataTypeDOc}</div>
          <div className="is--data">{client.numDocumento}</div>
        </div>
        <div className="cardInfo__data__items">
          <div className="is--title">Fecha de nacimiento</div>
          <div className="is--data">{client.fecNacimiento}</div>
        </div>
        <div className="cardInfo__data__items">
          <div className="is--title">Género</div>
          <div className="is--data">{modifierGenero}</div>
        </div>
      </div>
      <IconHolderInfo />
    </div>
  );
};

export default CardInfo;
